<template>
  <multi v-bind="$attrs"
         selectLabel="Seleccione"
         selectedLabel="selected"/>
</template>

<script>
  import multi from "vue-multiselect";

  export default {
    name: "multiselect",
    components: {multi}
  }
</script>

<style scoped>

</style>
